// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3ptvG","title":"ClientReferral_title__28_hc","itemText":"ClientReferral_itemText__WvQCW"};